import { buildEnrichedUser } from 'factories/users';
import { matchPath } from 'react-router-dom';
import { getTeamEntities, getTeamResult } from 'redux/selectors/teams';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import type { User } from 'types/user';
import { getUserRoleById } from './roles';
import { getEnrichedUser } from './user';

export const getCurrentlyViewedUserId = createSelector(
  [(state: IState) => state.router.location.pathname],
  (pathname): number => {
    const match = matchPath(`/:account_id/users/:user_id/*`, pathname);
    const userId = match?.params.user_id || undefined;
    return userId ? +userId : 0;
  }
);

export const readUsers = (state: IState): Array<User> => state.users.entries;

export const getSelectedUser = createSelector(
  [getCurrentlyViewedUserId, readUsers, getUserRoleById, getEnrichedUser],
  (userId, users, roleById, currentUser) => {
    const user = users.find(u => u.id === userId);
    return userId === currentUser.id || !user ? currentUser : buildEnrichedUser(user, roleById);
  }
);

export const getSelectedUserFromUrl = createSelector(
  [getCurrentlyViewedUserId, readUsers, getUserRoleById],
  (userId, users, roleById) => {
    const user = users.find(u => u.id === userId);
    return user ? buildEnrichedUser(user, roleById) : undefined;
  }
);

export const getTeamsForUser = createSelector(
  [getCurrentlyViewedUserId, getTeamResult, getTeamEntities],
  (userId, result, entities) => {
    return result
      .filter(team => entities[team].users.map(({ user_id }) => user_id).includes(userId))
      .map(team => entities[team]);
  }
);

export const getHasTeams = createSelector([getTeamsForUser], teams => !!teams.length);
